<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="display: flex;justify-content: space-between;">
        <div class="select">
          <div class="item">
            <el-button size="small" type='primary' @click="show('新增')">新增钱包配置</el-button>
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="416" size="small">
        <el-table-column label="钱包唯一标识" prop="walletUnique" />
        <el-table-column label="钱包地址" prop="url" />
        <el-table-column label="租户名称" prop="tenantName" />
        <el-table-column label="回调地址" prop="callBackUrl" />
        <el-table-column prop="" label="是否使用">
          <template slot-scope="scope">
            <span>{{ scope.row.actived == 0 ? '否' : '是' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show('编辑', scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="title" :visible="dialogVisible" width="400px" @close="close" :destroy-on-close="true">
        <el-form ref="formData" :model="formData" size="medium" label-width="120px">
          <el-form-item label="是否启用" prop="" :required="true">
            <el-switch v-model="formData.actived" :active-value="1" :inactive-value="0"> </el-switch>
          </el-form-item>
          <el-form-item label="权限key" prop="">
            <el-input v-model="formData.accessKey"></el-input>
          </el-form-item>
          <el-form-item label="回调地址" prop="">
            <el-input v-model="formData.callBackUrl"></el-input>
          </el-form-item>
          <el-form-item label="私钥" prop="">
            <el-input v-model="formData.privateKey"></el-input>
          </el-form-item>
          <el-form-item label="公钥" prop="">
            <el-input v-model="formData.publicKey"></el-input>
          </el-form-item>
          <el-form-item label="钱包地址" prop="" :required="true">
            <el-input v-model="formData.url"></el-input>
          </el-form-item>
          <el-form-item label="钱包唯一标识" prop="" :required="true">
            <el-input v-model="formData.walletUnique"></el-input>
          </el-form-item>
          <el-form-item label="钱包类型" prop="" :required="true">
            <el-select v-model="formData.walletType" placeholder="钱包类型" clearable>
              <el-option v-for="item in walletList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="租户id" prop="" :required="true">
            <el-select v-model="formData.tenantId" placeholder="租户id" clearable>
              <el-option v-for="item in tenantList" :key="item.id" :label="item.tenantName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from './api'
import { tenantInfo } from '@/common/publicApi'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      walletList: [],
      tenantList: [],
      tabList: [],
      dialogVisible: false,
      title: '新增',
      formData: {
        actived: 0,
        accessKey: '',
        callBackUrl: '',
        privateKey: '',
        publicKey: "",
        url: "",
        walletUnique: "",
        walletType: "",
        tenantId: ""
      }
    };
  },
  computed: {
  },
  mounted() {
    api.getWalletList().then(res => {
      if (res.code == 0) {
        this.walletList = res.data;
      }
    })

    tenantInfo().then(res => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    })
    this.handleSearch()
  },
  methods: {
    handleSearch() {
      api.getTenantWalletList().then(res => {
        if (res.code == 0) {
          const { data } = res;
          this.tabList = data
        }
      })
    },

    show(str, row) {
      if (row) {
        this.formData = row;
        this.formData.createdTime = undefined;
        this.formData.updatedTime = undefined;
      };
      this.title = str
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
      this.formData = {
        actived: 0,
        accessKey: '',
        callBackUrl: '',
        privateKey: '',
        publicKey: "",
        url: "",
        walletUnique: "",
        walletType: "",
        tenantId: ""
      }
    },
    handleSave() {
      if (this.formData.url == '') {
        return this.$message.error('请输入钱包地址')
      }
      if (this.formData.walletUnique == '') {
        return this.$message.error('请输入钱包唯一标识')
      }

      if (this.formData.tenantId == '') {
        return this.$message.error('请选择租户id')
      }
      if (this.formData.walletType == '') {
        return this.$message.error('请选择钱包类型')
      }

      let url = '';
      this.title === '新增' ? url = 'addTenantWallet' : url = 'updaTenantWallet'
      api[url](this.formData).then((res) => {
        if (res.code == 0) {
          this.$message.success(this.title + "成功");
          this.close();
          this.handleSearch();
        }
      });
    },
  },


};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
